import { atom } from 'jotai'

export const globalLoadingAtom = atom(false)

export const registrationEmailAtom = atom('')
